const GENERIC_REJECTION = {
    code: "DRAW_COMPLETION_REJECTED",
    message: "The current control points do not produce renderable geometry.",
    severity: "error",
};
export function evaluateCompletion(validate, candidate) {
    if (!validate)
        return { valid: true };
    try {
        const result = validate(candidate);
        if (typeof result === "boolean") {
            return result
                ? { valid: true }
                : rejectionFromIssues([GENERIC_REJECTION]);
        }
        if (result.valid)
            return { valid: true };
        return rejectionFromIssues(result.issues.length > 0 ? result.issues : [GENERIC_REJECTION]);
    }
    catch (error) {
        return rejectionFromIssues([
            {
                code: "DRAW_COMPLETION_VALIDATION_FAILED",
                message: error instanceof Error
                    ? error.message
                    : "Draw completion validation failed.",
                severity: "error",
            },
        ]);
    }
}
function rejectionFromIssues(issues) {
    return {
        valid: false,
        rejection: {
            kind: "completion-validation",
            issues: issues.map((issue) => ({ ...issue })),
        },
    };
}
//# sourceMappingURL=completion-validation.js.map